// extracted by mini-css-extract-plugin
export default {"renameModal":"styles_renameModal__gTaX2","header":"styles_header__vqvll","title":"styles_title__HGXpj","inputField":"styles_inputField__sIMh0","input":"styles_input__uhKIR"};